import React, { useState } from "react";

import {
	Button,	
	useListContext,
} from "react-admin";

import { useGridUserDataContext } from "contexts/GridUserDataProvider";


// TODO investigate why there are several requests to backend when click on reset button and fix it
const ResetUserGridDataButton = (props) => {
	const { setFilters, setSort } = useListContext();
	const { getFilterDefaultValues, getSortDefaultValues } = useGridUserDataContext();

	const handleReset = () => {
		const defaultFilterValues = getFilterDefaultValues();
		setFilters(defaultFilterValues, {}, false);
		const defaultSort = getSortDefaultValues();
		setSort(defaultSort.field, defaultSort.order);
	};

	return (
		<Button
			{...props}
			label="osfc.button.reset_user_grid_data"
			alignIcon="left"
			onClick={handleReset}
		/>		
	);
};

export { ResetUserGridDataButton as default };
